module.exports = __webpack_public_path__ + "img/section5Logo2.10ae0a03.svg";